// import React from "react";
import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./SmartOptionsCompleteIndex.css";
import URLstateContext from "../../../provider/CommonContext";
import index1 from "./Nifty50.png";
import index2 from "./BankNifty.png";
import index3 from "./Finnifty.png";
import index4 from "./NiftyMidcap.png";
import upArrow from "../../../../src/Images/New_Home/images/up.svg";
import  down from "../../../../src/Images/New_Home/images/down.png";
const ImgData = [
  { id: 1, imgName: index1 },
  { id: 2, imgName: index2 },
  { id: 3, imgName: index3 },
  { id: 4, imgName: index4 },
]

function SmartOptionsCompleteIndex() {
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  let getData;

  useEffect(() => {
    const getUrl = BaseURL + "Index";
    fetch(`${getUrl}`)
      .then((response) => response.json())
      .then((data) => {
        getData = data.data;
        setData(getData);
      })
      .catch((error) => {
      });
  }, [])
  console.log(ImgData);
  return (
    <>
      <section className="SmartOptionsCompleteIndex_section">
        <Container>
          <div className="section-heading center">
            The Complete index Option<br></br><span>Trading Experience</span>
          </div>
          <Row>
          {data && data.slice(0, 4).map((item, index) => {
              return (
                <Col sm={6} >
                  <div Key={index} className="SmartOptionsCompleteIndex_group">
                    <div className="SmartOptionsCompleteIndex_panel">
                      <div className="SmartOptionsCompleteIndex_imgpanel">
                        <span>
                          <img src={ImgData && ImgData[index] && ImgData[index].imgName} alt={`Image ${index}`} className="img-fluid" />
                        </span>
                      </div>
                      <div className="SmartOptionsCompleteIndex_contspanel">
                        <h2>{item.co_name}</h2>
                        <p>
                          <span class={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>{item.close_price}
                          {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg"  src={down} alt="Down Arrow" />}
                            </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )
            })
            }
          </Row>
        </Container>
      </section>
    </>
  );
}
export default SmartOptionsCompleteIndex;
